module.exports = __webpack_public_path__ + "img/Gift-Cards-Pop-up.affeda5f.png";